export const dev = {
  env: 'dev',
  // baseUrl: 'http://206.189.198.15:82',
  //baseUrl: 'https://zaidint.herokuapp.com',
  baseUrl: process.env['REACT_APP_BASE_URL'],
  // baseUrl: 'https://zaidint.ng',
  version: 1,
};
